// api
import { fetchApi } from '@/api'
// actions
const restaurantDeliveriesAll = (context) => {
  let url = 'restaurant/deliveries'
  let data = {}
  fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('RESTAURANT_DELIVERIES_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantDeliveriesForm = (context) => {
  let url = 'restaurant/deliveries/create'
  let data = {}
  fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('RESTAURANT_DELIVERIES_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantDeliveriesShow = (context) => {
  let url = 'restaurant/deliveries'
  let data = {}
  fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('RESTAURANT_DELIVERIES_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const restaurantDeliveriesCreate = (context) => {
  let url = 'restaurant/deliveries/create'
  let data = {}
  fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('RESTAURANT_DELIVERIES_CREATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantDeliveriesUpdate = (context) => {
  let url = 'restaurant/deliveries'
  let data = {}
  fetchApi(url, data, 'PUT')
    .then((response) => {
      context.commit('RESTAURANT_DELIVERIES_UPDATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantDeliveriesDelete = (context, payload) => {
  let url = 'restaurant/deliveries'
  console.log(payload)
  fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('RESTAURANT_DELIVERIES_DELETE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  restaurantDeliveriesAll,
  restaurantDeliveriesForm,
  restaurantDeliveriesShow,
  restaurantDeliveriesCreate,
  restaurantDeliveriesUpdate,
  restaurantDeliveriesDelete
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/deliveries/actions.js